<template>
  <div class="home">
    <header id="header" class="header home-hero">
      <div class="container">
        <ImageAndText />
      </div>
    </header>

    <!-- Pendidikan Section -->
    <section
      id="pendidikan"
      class="section-padding bg-light-gray modern-section section-overlay"
      v-motion
      :initial="motionVariant(50, 0, 0.35)"
      :visible-once="motionVariant(0, 0, 0.9)"
    >
      <div class="container">
        <div class="content-box content-box--glass">
          <div class="row align-items-center">
            <div class="col-lg-12 text-center mb-5" v-motion :initial="motionVariant(30, 0, 0.2)" :visible-once="motionVariant(0, 0, 0.65)">
              <h2 class="section-title section-title--modern">
                PENDIDIKAN ADALAH <span class="text-gradient">INVESTASI TERBESAR</span> NEGARA
              </h2>
              <p class="section-subtitle">Membangun ekosistem sekolah digital yang relevan, human-centered, dan efisien.</p>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-lg-6 col-xl-7 mb-4 mb-lg-0" v-motion :initial="motionVariant(0, -60, 0.2)" :visible-once="motionVariant(0, 0, 0.85)">
              <div class="image-container hover-lift">
                <img
                  class="img-fluid rounded-4 shadow-sm modern-image"
                  :src="require('@/assets/pendidikan.png')"
                  alt="image pendidikan"
                />
              </div>
            </div>
            <div class="col-lg-6 col-xl-5" v-motion :initial="motionVariant(0, 50, 0.3)" :visible-once="motionVariant(0, 0, 0.9)">
              <div class="text-container ps-lg-4 modern-text-block">
                <p class="p-large text-muted">
                  Peran sistem dan Aplikasi Digital sangat menunjang untuk membentuk mutu pembelajaran Sekolah Cerdas
                  (Smart School) dan menjadi bagian dari kemajuan Pendidikan di Indonesia.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Kendala Section -->
    <section
      id="tentang-sekolah"
      class="section-padding modern-section"
      v-motion
      :initial="motionVariant(55, 0, 0.3)"
      :visible-once="motionVariant(0, 0, 0.9)"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-xl-5 mb-4 mb-lg-0 order-2 order-lg-1" v-motion :initial="motionVariant(0, -50, 0.2)" :visible-once="motionVariant(0, 0, 0.85)">
            <div class="text-container pe-lg-4">
              <h3 class="h3-large mb-4 modern-heading">
                KENDALA SEKOLAH MENERAPKAN <br /><span class="text-primary">SMART SCHOOL</span>
              </h3>
              <div class="feature-list modern-feature-list">
                <div
                  class="feature-item mb-3"
                  v-motion
                  :initial="motionVariant(18, 0, 0.35)"
                  :visible-once="motionVariant(0, 0, 0.8)"
                >
                  <p class="p-large text-muted">
                    Hanya di Diskola, penggunaan aplikasi GRATIS & sistem yang efisien — kami memenuhi kebutuhan sekolah
                    yang unik & beragam.
                  </p>
                </div>
                <div class="feature-item" v-motion :initial="motionVariant(18, 0, 0.5)" :visible-once="motionVariant(0, 0, 0.92)">
                  <p class="p-large text-muted">
                    diskola.id menghadirkan produk berkualitas melalui berbagai riset di divisi penelitian dan
                    pengembangan bisnis perusahaan sesuai problem yang ada di lapangan.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-7 order-1 order-lg-2" v-motion :initial="motionVariant(0, 60, 0.35)" :visible-once="motionVariant(0, 0, 0.95)">
            <div class="image-container hover-lift">
              <img
                class="img-fluid rounded-4 modern-image"
                :src="require('@/assets/pendidikan-adalah.png')"
                alt="image pendidikan face"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Solusi Section -->
    <section
      id="solusi"
      class="section-padding bg-primary-gradient modern-section modern-section--dark"
      v-motion
      :initial="motionVariant(45, 0, 0.3)"
      :visible-once="motionVariant(0, 0, 0.92)"
    >
      <div class="container">
        <div class="row mb-5">
          <div class="col-lg-12 text-center" v-motion :initial="motionVariant(26, 0, 0.2)" :visible-once="motionVariant(0, 0, 0.72)">
            <h2 class="text-white mb-3 section-title--modern">APA YANG KAMI LAKUKAN UNTUK MEMBANTU</h2>
            <p class="text-white-50 lead modern-lead">Solusi komprehensif untuk kebutuhan digital sekolah Anda</p>
          </div>
        </div>
        <div class="row g-4">
          <!-- Card 1 -->
          <div class="col-lg-4" v-motion :initial="motionVariant(35, 0, 0.25)" :visible-once="motionVariant(0, 0, 0.85)">
            <div class="card solution-card solution-card--web h-100 border-0 p-4 modern-card">
              <div class="card-icon-wrapper mb-4">
                <img class="img-fluid" :src="require('@/assets/card1.png')" alt="icon" />
              </div>
              <div class="card-body p-0">
                <h5 class="card-title mb-3">Kemudahan Pelayanan PPDB</h5>
                <p class="card-text text-muted">
                  Sistem layanan kami mendukung pelayanan dan pembayaran pendaftaran untuk Penerimaan Peserta Didik
                  baru, Penerimaan Siswa baru, dan Daftar ulang.
                </p>
              </div>
            </div>
          </div>

          <!-- Card 2 -->
          <div class="col-lg-4" v-motion :initial="motionVariant(35, 0, 0.45)" :visible-once="motionVariant(0, 0, 1)">
            <div class="card solution-card solution-card--edu h-100 border-0 p-4 modern-card">
              <div class="card-icon-wrapper mb-4">
                <img class="img-fluid" :src="require('@/assets/card2.png')" alt="icon" />
              </div>
              <div class="card-body p-0">
                <h5 class="card-title mb-3">Aplikasi Pembelajaran Sekolah</h5>
                <p class="card-text text-muted">
                  Pelaksanaan belajar dan ujian secara online untuk sekolah, berbasis aplikasi. Kami hadirkan Layanan
                  Materi pembelajaran, tugas dan ujian online.
                </p>
              </div>
            </div>
          </div>

          <!-- Card 3 -->
          <div class="col-lg-4" v-motion :initial="motionVariant(35, 0, 0.65)" :visible-once="motionVariant(0, 0, 1.15)">
            <div class="card solution-card solution-card--bayar h-100 border-0 p-4 modern-card">
              <div class="card-icon-wrapper mb-4">
                <img class="img-fluid" :src="require('@/assets/card3.png')" alt="icon" />
              </div>
              <div class="card-body p-0">
                <h5 class="card-title mb-3">Manajemen & Sistem Finansial</h5>
                <p class="card-text text-muted">
                  Dengan Diskola semua bisa mengakses layanan dengan mudah, semua dirancang agar mudah digunakan, mulai
                  dari guru, karyawan, siswa sampai dengan orang tua.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ImageAndText from "@/components/ImageAndText.vue";
import { useMotionVariants } from "@/composables/useMotionVariants";

export default {
  name: "HomeView",
  components: { ImageAndText },
  setup() {
    const { motionVariant } = useMotionVariants();
    return { motionVariant };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.home {
  background: linear-gradient(180deg, var(--surface-elevated) 0%, var(--surface) 22%, var(--surface) 100%);
}

.home-hero {
  position: relative;
  isolation: isolate;
}

.section-overlay {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    width: min(460px, 58vw);
    height: min(460px, 58vw);
    border-radius: 50%;
    top: -200px;
    right: -170px;
    background: radial-gradient(circle, rgba(var(--color-primary-rgb), 0.16) 0%, transparent 72%);
    pointer-events: none;
    animation: blob-drift 28s ease-in-out infinite;
  }
}

.modern-section {
  position: relative;
  padding-top: clamp(4.75rem, 9vw, 6.5rem);
  padding-bottom: clamp(4.75rem, 9vw, 6.5rem);
}

.bg-light-gray {
  background: linear-gradient(180deg, var(--surface) 0%, var(--surface-elevated) 100%);
}

.bg-primary-gradient {
  background: linear-gradient(135deg, #04606c 0%, #034c56 100%);
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("~@/assets/decoration-circles.png") no-repeat center center;
    opacity: 0.1;
    pointer-events: none;
  }
}

.content-box {
  background: var(--surface);
  padding: 40px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border);
}

.content-box--glass {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(var(--color-primary-rgb), 0.12);
  box-shadow: 0 30px 70px -35px rgba(var(--color-primary-rgb), 0.35),
    0 20px 40px -30px rgba(var(--color-primary-rgb), 0.45);
}

.section-title {
  font-size: 2.5rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
}

.section-title--modern {
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.section-subtitle {
  color: var(--text-muted);
  max-width: 44rem;
  margin: 0 auto;
  font-size: clamp(1rem, 2.2vw, 1.1rem);
  line-height: 1.75;
}

.modern-heading {
  line-height: 1.25;
  letter-spacing: -0.01em;
}

.modern-text-block {
  position: relative;
  padding: 1.35rem 1.4rem;
  border: 1px solid var(--border);
  border-radius: 18px;
  background: linear-gradient(
    145deg,
    rgba(var(--color-primary-rgb), 0.02) 0%,
    rgba(var(--color-primary-rgb), 0.07) 100%
  );
}

.modern-image {
  box-shadow: 0 18px 40px -25px rgba(var(--color-primary-rgb), 0.45), 0 24px 50px -38px rgba(15, 23, 42, 0.5);
  border: 1px solid var(--border);
}

.modern-feature-list .feature-item {
  background: var(--surface);
  border-radius: 16px;
  border: 1px solid var(--border);
  padding: 1.1rem 1.2rem;
  box-shadow: 0 12px 26px -28px rgba(var(--color-primary-rgb), 0.5);
  transition: transform var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out);

  &:hover {
    transform: translateY(var(--hover-lift));
    box-shadow: var(--shadow-md);
  }
}

// Aksen per kartu solusi
.solution-card--web {
  --card-accent: var(--accent-web);
  --card-accent-rgb: var(--accent-web-rgb);
}
.solution-card--edu {
  --card-accent: var(--accent-edu);
  --card-accent-rgb: var(--accent-edu-rgb);
}
.solution-card--bayar {
  --card-accent: var(--accent-bayar);
  --card-accent-rgb: var(--accent-bayar-rgb);
}

.solution-card {
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  transition: transform var(--dur-base) var(--ease-out), box-shadow var(--dur-base) var(--ease-out),
    border-color var(--dur-base) var(--ease-out);
  border: 1px solid transparent;
  border-top: 3px solid var(--card-accent, var(--color-primary));

  &:hover {
    transform: translateY(-10px);
    box-shadow: var(--shadow-lg), 0 18px 40px -24px rgba(var(--card-accent-rgb), 0.4);
    border-color: rgba(var(--card-accent-rgb), 0.3);
    border-top-color: var(--card-accent);
  }

  &:focus-within {
    outline: 2px solid rgba(var(--card-accent-rgb), 0.45);
    outline-offset: 4px;
    border-color: rgba(var(--card-accent-rgb), 0.3);
  }

  .card-title {
    font-weight: 700;
    color: $text-dark;
  }

  .card-icon-wrapper {
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(var(--card-accent-rgb), 0.12);
    border-radius: 16px;

    img {
      width: 40px;
    }
  }
}

.modern-card {
  background: linear-gradient(160deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.88) 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.22) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.22) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.22) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 30px 40px -30px rgba(2, 62, 70, 0.9), 0 14px 30px -30px rgba(15, 23, 42, 0.85);
}

[data-theme="dark"] .modern-card {
  background: linear-gradient(160deg, rgba(17, 27, 43, 0.92) 0%, rgba(17, 27, 43, 0.82) 100%);
  border-right-color: rgba(148, 163, 184, 0.14) !important;
  border-bottom-color: rgba(148, 163, 184, 0.14) !important;
  border-left-color: rgba(148, 163, 184, 0.14) !important;

  .card-title {
    color: var(--text);
  }
}

.image-container img {
  transition: transform var(--dur-slow) var(--ease-out), filter var(--dur-slow) var(--ease-out);
}

.image-container:hover img {
  transform: scale(1.015);
  filter: saturate(1.03);
}

.modern-section--dark {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.modern-lead {
  max-width: 38rem;
  margin-left: auto;
  margin-right: auto;
}

.text-primary {
  color: var(--color-primary) !important;
}

@media (hover: hover) and (pointer: fine) {
  .solution-card,
  .image-container img {
    will-change: transform;
  }
}

@media (max-width: 991.98px) {
  .content-box {
    padding: 26px;
  }

  .modern-text-block {
    padding: 1rem 1.1rem;
  }

  .content-box--glass,
  .modern-card {
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }

  .content-box--glass {
    box-shadow: 0 18px 30px -28px rgba(var(--color-primary-rgb), 0.38);
  }

  .modern-card {
    box-shadow: 0 18px 28px -28px rgba(2, 62, 70, 0.65);
  }
}
</style>
